// How many rows a list page asks the server for.
//
// Two values, because two shells with different expectations render the same tables.
//
// The v2 consoles use DEFAULT_PAGE_SIZE (20) everywhere: pharmacy
// orders/quotations/inventory, ops orders/b2b/TAT, and the two shared legacy tables the
// consoles embed -- orderTable/orders.jsx (the Reorders tab in both consoles) and
// quotationsTable/quotations.jsx (the ops Quotations tab).
//
// Those same two files also render at six legacy routes -- /all-orders,
// /partner-orders, /future-orders, /user-details/:id, /digitize-orders and /quotations
// -- where the long-standing page length is 50 and people are used to it. They keep it,
// via LEGACY_DEFAULT_PAGE_SIZE. Each table picks between the two by asking
// consoleForPath() (./consoles.js) which shell it is mounted in, so one component can
// serve both without either shell having to remember to pass anything.
//
// Before this, the size was written out ten separate times and had drifted: the legacy
// tables and ops orders asked for 50, the TAT dashboard for 10 (inherited from a
// prototype fixture, not a decision), everything else 20 -- three different answers to
// "how long is a page" inside one product.
//
// 20 matches pillup-api's own DEFAULT_SIZE (classes/Generic/Constants.js), so the value
// the frontend sends and the value the backend would have picked on its own now agree.
// The frontend still always sends `size` explicitly rather than relying on that default
// -- the two repos deploy independently, and a page length that silently changes with a
// backend release is not something you want to debug from the UI side.
//
// Neither is a hard cap: getSize() in classes/Generic/Functions.js clamps anything
// larger to MAX_SIZE (500), so a caller asking for more gets a bounded answer rather
// than an unbounded query.
export const DEFAULT_PAGE_SIZE = 20;

/**
 * The page length the legacy dashboard has always used. Applies only when one of the
 * shared tables is mounted OUTSIDE a v2 console -- it is deliberately not a fallback
 * anyone should reach for in new code.
 */
export const LEGACY_DEFAULT_PAGE_SIZE = 50;

/**
 * The largest page the API will return -- mirrors MAX_SIZE in pillup-api's
 * classes/Generic/Constants.js. Asking for more is silently clamped to this, which makes
 * the count and the rows on screen disagree, so page-size inputs cap at it and exports
 * page through at it.
 */
export const MAX_PAGE_SIZE = 500;
